/**
 * 部门业绩详情弹窗
 */

import React from 'react';
import { Modal, Table, Space, Tag, Spin } from 'antd';
import { RiseOutlined, FallOutlined, TeamOutlined, TrophyOutlined } from '@ant-design/icons';
import type { ColumnsType } from 'antd/es/table';
import { PerformanceRecord, DepartmentPerformanceDetail } from '../../../services/administrationService';

interface DepartmentDetailModalProps {
    visible: boolean;
    loading: boolean;
    detail: DepartmentPerformanceDetail | null;
    onCancel: () => void;
}

const DepartmentDetailModal: React.FC<DepartmentDetailModalProps> = ({
    visible,
    loading,
    detail,
    onCancel
}) => {

    // 渲染排名徽章 (Helper)
    const renderRankBadge = (rank: number | null) => {
        if (rank === null) return '-';
        let className = ''; // Assuming parent css handles colors or use inline
        let color = '#d9d9d9';
        if (rank === 1) color = '#fadb14';
        if (rank === 2) color = '#d3d3d3';
        if (rank === 3) color = '#b87333';

        return (
            <span style={{
                display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
                width: 24, height: 24, borderRadius: '50%', background: color, color: '#fff'
            }}>
                {rank <= 3 ? <TrophyOutlined /> : rank}
            </span>
        );
    };

    const columns: ColumnsType<PerformanceRecord> = [
        {
            title: '指标',
            dataIndex: 'dimension_name',
            key: 'dimension_name',
        },
        {
            title: '实际值',
            dataIndex: 'actual_value',
            key: 'actual_value',
            align: 'right',
            render: (val: number) => val?.toFixed(2) ?? '-',
        },
        {
            title: '目标值',
            dataIndex: 'target_value',
            key: 'target_value',
            align: 'right',
            render: (val: number | null) => val ? val.toFixed(2) : '-',
        },
        {
            title: '完成率',
            dataIndex: 'completion_rate',
            key: 'completion_rate',
            align: 'right',
            render: (rate: number | null) => {
                if (rate === null) return '-';
                const icon = rate >= 100 ? <RiseOutlined /> : <FallOutlined />;
                const color = rate >= 100 ? '#52c41a' : rate >= 80 ? '#faad14' : '#ff4d4f';
                return (
                    <Tag color={color} icon={icon}>
                        {rate.toFixed(1)}%
                    </Tag>
                );
            },
        },
        {
            title: '权重',
            dataIndex: 'weight',
            key: 'weight',
            align: 'right',
            render: (w: number | null) => w ? `${w}%` : '-',
        },
        {
            title: '得分',
            dataIndex: 'score',
            key: 'score',
            align: 'right',
            render: (s: number | null) => s ? s.toFixed(2) : '-',
        },
    ];

    return (
        <Modal
            title={
                <Space>
                    <TeamOutlined />
                    {detail?.department_name} - 业绩详情
                </Space>
            }
            open={visible}
            onCancel={onCancel}
            footer={null}
            width={800}
        >
            <Spin spinning={loading}>
                {detail && (
                    <div>
                        <div style={{
                            marginBottom: 24,
                            padding: 16,
                            background: '#f5f5f5',
                            borderRadius: 8
                        }}>
                            <Space size="large">
                                <span>
                                    <strong>总得分: </strong>
                                    <span style={{ fontSize: 20, color: '#1890ff' }}>
                                        {detail.total_score.toFixed(1)}
                                    </span>
                                </span>
                                <span>
                                    <strong>排名: </strong>
                                    {renderRankBadge(detail.rank)}
                                </span>
                            </Space>
                        </div>
                        <Table
                            columns={columns}
                            dataSource={detail.records}
                            rowKey="id"
                            pagination={false}
                            size="small"
                        />
                    </div>
                )}
            </Spin>
        </Modal>
    );
};

export default DepartmentDetailModal;
